module.exports = __webpack_public_path__ + "static/media/svg.9dea8d1d.svg";